var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFileLargeUkeoi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_3125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4H36L40 8L44 12V46H6V4Z",
    fill: "#F9C030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11L17 16L21 11",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16V23",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17H22",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20H22",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 13,
    fill: "#0098CB",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0321 29.104V30.272H29.4401V29.104H34.0321ZM34.6081 31.2161V32.4001H28.6401V31.2161H34.6081ZM34.0641 33.392V34.5441H29.3761V33.392H34.0641ZM29.3761 36.6881V35.5201H34.0641V36.6881H29.3761ZM32.8001 38.8801H30.6401V41.1841H32.8001V38.8801ZM34.0801 37.6801V42.3841H30.6401V43.0561H29.3601V37.6801H34.0801ZM37.1041 39.2641H40.9921V38.3041H37.1041V39.2641ZM40.9921 36.3361H37.1041V37.2961H40.9921V36.3361ZM42.3841 35.248V41.7761C42.3841 42.4481 42.2401 42.8 41.7921 43.008C41.3121 43.2001 40.6081 43.2001 39.6001 43.2001C39.5521 42.8481 39.3921 42.3361 39.2161 42.0001C39.8721 42.0321 40.5281 42.0161 40.7201 42.0161C40.9281 42.0001 40.9921 41.9521 40.9921 41.7601V40.2881H37.1041V43.2321H35.7281V35.248H42.3841ZM39.6161 33.3601H43.2961V34.4481H34.5761V33.3601H38.2081V32.4801H35.3761V31.4401H38.2081V30.64H34.9601V29.552H38.2081V28.576H39.6161V29.552H42.9761V30.64H39.6161V31.4401H42.7201V32.4801H39.6161V33.3601Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_3125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileLargeUkeoi);
export default __webpack_public_path__ + "static/media/icon-file_large-ukeoi.f183bdb5e0b6376a512dfd086ac20161.svg";
export { ForwardRef as ReactComponent };